import { Procedure } from "@/services/backend/procedures/procedure/procedure";
import {
  EvaluableType,
  SampleError,
} from "@/services/backend/sample-error/sample-error";
import { SampleSet } from "@/services/backend/sample-set/sample-set";
import { useGetSampleSetQuery } from "@/services/backend/sample-set/service";
import { SampleType } from "@/services/backend/types";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { Badge } from "@/shared/components/ui/badge";
import { ReactNode } from "react";

/* function scaleToCubicMeter(measurement: number, samplingVolume: number): number {
  if (samplingVolume === 0) {
    return 0; // safety check
  }
  const value = measurement * (1000.0 / samplingVolume);
  return Math.round(value);
} */

function checkIfNotEvaluable(sampleSet: SampleSet | undefined): boolean {
  if (sampleSet != null) {
    const errors: SampleError[] = [];
    sampleSet.samples.forEach((s) =>
      s.sampleErrors.forEach((e) => errors.push(e)),
    );

    const notEvaluable = errors.some(
      (e) => e.evaluableType === EvaluableType.NotEvaluable,
    );

    return notEvaluable;
  }
  return false;
}

interface ResultLabelProps {
  procedure: Procedure;
}

function ResultLabel({ procedure }: ResultLabelProps): ReactNode {
  const { data: sampleSet, error: sampleSetError } = useGetSampleSetQuery({
    id: procedure.sampleSetId,
  });
  const notEvaluable = checkIfNotEvaluable(sampleSet);
  if (sampleSetError) {
    return <RTKQueryErrorAlert error={sampleSetError} />;
  }

  if (notEvaluable) {
    return <Badge className="bg-red-600">n.a.</Badge>;
  }

  if (procedure.result.exceedsThreshold) {
    if (procedure.sampleType === SampleType.SurfaceMicrobial) {
      return <span>&gt;100</span>;
    }

    if (sampleSet && sampleSet.samplingVolume) {
      return <span>&gt;1000</span>;
    }
  }

  return <span>{procedure.result.value}</span>;
}

export default ResultLabel;
